// Cookie-consent store. Persisted in localStorage; a window event lets the
// analytics loader react to a fresh decision without a page reload.

const STORAGE_KEY = 'nsave-cookie-consent';
export const CONSENT_EVENT = 'nsave-consent-change';

export type ConsentValue = 'accepted' | 'rejected';

export function getConsent(): ConsentValue | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch {
    return null;
  }
}

export function setConsent(value: ConsentValue) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Ignore private mode / disabled storage. The current page still receives the event.
  }
  window.dispatchEvent(new CustomEvent<ConsentValue>(CONSENT_EVENT, { detail: value }));
}
